import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";
import { useFormContext } from "react-hook-form";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { EnumHelper } from "src/components/../helpers/EnumHelper";
import { useTranslation } from "react-i18next";

export const DistributionOfLandedCostsDetailExpenses = () => {
    const tableName = "expenses";
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={tableName}>
                {/*<NFLookupExpenseItem fieldName={"expenseItemId"} title={t("ExpenseItem")} />*/}
                <NFLookupAccount
                    title={t("Account")}
                    fieldName="expenseAccountId"
                />
                <NFLookupInput
                    title={t("DistributionRule")}
                    fieldName={"distributionRule"}
                    items={EnumHelper.getDistributionOfLandingCostsRuleEnum(t)}
                />
                <NFIntInput
                    fieldName={"amount"}
                    title={t("Amount")}
                    width={100}
                />
                {/*<NFIntInput*/}
                {/*    fieldName={"balance"}*/}
                {/*    title={t("Balance")}*/}
                {/*    width={100}*/}
                {/*/>*/}
                {/*<NFLookupCurrency*/}
                {/*    fieldName={"currencyId"}*/}
                {/*    title={t("Currency")}*/}
                {/*/>*/}
            </NFormTable>
        </>
    );
};
